import React from 'react';
import { UnderlineNav } from '@primer/react'

export default function Nav() {
  return (
    <UnderlineNav aria-label="sections" className="mb-3">
      <UnderlineNav.Item href="/" aria-current={ariaCurrent("/")}>About</UnderlineNav.Item>
      <UnderlineNav.Item href="/resume" aria-current={ariaCurrent("/resume")}>Resume</UnderlineNav.Item>
      <UnderlineNav.Item href="/projects" aria-current={ariaCurrent("/projects")}>Projects</UnderlineNav.Item>
    </UnderlineNav>
  );
}

function ariaCurrent(checking: string): 'page' | 'step' | 'location' | 'date' | 'time' | 'true' | 'false' | boolean | undefined {
  return window.location.pathname === checking ? 'page' : undefined;
}